import React, { useState, useEffect, useMemo } from 'react'

import CityProgramView from '../../CityProgramView'
import { CITY_PROGRAMS, tableColumnsReferral } from '../../options'
import useGraphQLFetch from '../../../../../../Utils/Hooks/useGraphQLFetch'
import {
  createReferralCampaign,
  disableReferralCampaign,
  getReferralPrograms,
} from './gql'
import { apiClient } from '../../../../../../Module/API/Client'

const CityReferralCampaign = ({ cityId }) => {
  const [isActive, setIsActive] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const [maxBudget, setMaxBudget] = useState(0)
  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getReferralPrograms,
    defaultFetchArgs: { cityId },
    mapResponse: data => data.referralPrograms,
    fetchId: 'getReferralPrograms',
  })

  useEffect(() => {
    if (isLoaded) {
      setIsActive(data.isActive)
    }
  }, [isLoaded])

  const onUpdate = (item, form) => {
    const { bonusAmount, signUpLimit, missionsTrigger } = form
    if (
      bonusAmount &&
      Number(bonusAmount.value) &&
      (signUpLimit && Number(signUpLimit.value))
    ) {
      setMaxBudget(bonusAmount.value * signUpLimit.value * 2)
    } else {
      setMaxBudget(0)
    }

    if (
      bonusAmount &&
      bonusAmount.isValid &&
      (signUpLimit && signUpLimit.isValid) &&
      (missionsTrigger && missionsTrigger.isValid)
    ) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }

  const onSubmit = async (form, isValid) => {
    if (isValid) {
      const { bonusAmount, signUpLimit, missionsTrigger } = form
      try {
        await createReferralCampaign({
          cityId: Number(cityId),
          requiredMissions: Number(missionsTrigger.value),
          bonusAmount: Number(bonusAmount.value),
          signUpsLimit: Number(signUpLimit.value),
        })

        refetch({ cityId })
      } catch (e) {
        console.error({ e })
      }
    }
  }

  const onToggle = async () => {
    if (isActive) {
      try {
        await disableReferralCampaign({
          cityId: Number(cityId),
        })
        refetch({ cityId })
        setIsActive(!isActive)
      } catch (e) {
        console.error({ e })
      }
    }
  }

  const exportLink = useMemo(() => {
    return apiClient.getURLOfReferralProgramsCSV(cityId)
  }, [cityId])

  return isLoaded ? (
    <CityProgramView
      onToggle={onToggle}
      exportLink={exportLink}
      tableColumns={tableColumnsReferral}
      tableData={data.nodes}
      isActive={isActive}
      programType={CITY_PROGRAMS.REFERRAL}
      onSubmit={onSubmit}
      onUpdate={onUpdate}
      isDisabled={isDisabled}
      maxBudget={maxBudget}
      cypressId="edit-city-ba-referral-section"
    />
  ) : (
    <div>Loading...</div>
  )
}

export default CityReferralCampaign
